import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { environment } from '../../../../environments/environment';

// Interfaces
import { IService } from '../../interfaces';

@Injectable()
export class LogService implements IService {
  // implements local variables
  // *

  // implements IService
  name = 'LogService';
  test(name, value) {
    console.log('testing', name, value);
  }


  constructor() { }

  Debug(module: string, messages: any[]) {
    if (environment.LogDebug) {
      this._log('DEBUG' + ' | ' + module, messages);
    }
  }

  DebugMsg(module: string, message: string) {
    if (environment.LogDebug) {
      this._log('DEBUG' + ' | ' + module, message);
    }
  }

  Info(mod: string, messages: any[], sendEmail?: boolean) {
    if (environment.LogInfo) {
      this._log('INFO' + ' | ' + module, messages);
    }
    // send email
    // if (sendEmail) {
    //   this._emailService.sendToDev(
    //      messages.join(' | '),
    //      'INFO',
    //      'Info from CUAP'
    //   ).subscribe(success => {
    //     'An email was sent'.log(this.name);
    //   }, err => {
    //     'An error occured while sending an email: '.logWithObject(this.name, err);
    //   });
    // }
    // send to server
    this._serverLog(false, mod, messages, '');
  }

  Error(mod: string, messages: any[], stack = '') {
    if (environment.LogError) {
      this._log('ERROR' + ' | ' + module, messages);
    }

    // this._emailService.sendToDev(
    //   messages.join(' | '),
    //   'ERROR',
    //   'Error from CUAP'
    // ).subscribe(success => {
    //   'An email was sent'.log(this.name);
    // }, err => {
    //   'An error occured while sending an email: '.logWithObject(this.name, err);
    // });

    // send to server
    this._serverLog(true, mod, messages, stack);
  }



  private _log(module: string, messages: any) {
    //console.log(environment.base.name + ' | ' + module.toUpperCase() + ' | ', messages);
  }

  private _handleError(error: Response, caugth: Observable<any>) {
    return Observable.throw(error);
  }

  private _serverLog(isError: boolean, mod: string, messages: any[], stack = '') {
    const msgs = [];
    msgs.push(environment.base.name);
    msgs.push(environment.base.version);
    messages.forEach(m => {
      msgs.push(JSON.stringify(m));
    });

    // send to server
    // this._errorService.ServerLog(
    //   isError,
    //   {
    //     name: mod,
    //     message: msgs.join(' | '),
    //     stack: stack
    //   }).subscribe();
  }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/log/log.service.ts